module.exports = __webpack_public_path__ + "static/img/70 (2).340fd07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/70 (2).jpg
// module id = 8fGP
// module chunks = 0